.d{align-items:center;}